import React from 'react';
import { StyleSheet } from 'react-native';
import { Box, Stack, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { IContestAward, IUserSummary } from '../../types/global/helper';
import { Wreathe } from '../Wreathe/Wreathe';

export interface IContestAwardProps {
    contestAwards?: IContestAward[];
    onWinnerClick?: (user: IUserSummary) => void;
}

const ContestAwards: React.FC<IContestAwardProps> = ({ contestAwards, onWinnerClick }) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);

    return (
        <Stack sx={{ backgroundColor: theme[themeStyle].secondaryBg, borderRadius: 3, width: '100%', padding: 5 }}>
            <Typography
                style={{
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    fontSize: 24,
                    color: theme[themeStyle].tag_white,
                    alignSelf: 'center',
                    marginBottom: 10,
                }}>
                Winners
            </Typography>
            <Box
                style={styles.box}
                sx={{
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: { xs: 'fit-content', sm: 'fit-content' },
                    width: { xs: '100%', sm: '100%' },
                    gap: '30px',
                    flexWrap: 'wrap',
                }}>
                {contestAwards?.map((award, index) => (
                    <Stack direction="column" alignItems="center" key={index}>
                        <Wreathe
                            contestAward={award}
                            withImage
                            onWreatheClick={() => onWinnerClick && onWinnerClick(award.person_awarded)}
                        />
                        {!!award && award.award_category && award.award_category.category_title && (
                            <Typography
                                style={{
                                    fontFamily: FONT_ENUM.REGULAR_HEADER,
                                    fontSize: 12,
                                    color: theme[themeStyle].tag_white,
                                    marginTop: 10,
                                }}>
                                {award.award_category.category_title}
                            </Typography>
                        )}
                    </Stack>
                ))}
            </Box>
        </Stack>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        box: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            borderRadius: 10,
        },
    });

export { ContestAwards };
